import KeepAlive from "react-activation"
import { useLocation } from "react-router-dom"
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from "shj-components"
import config from './config.json';
import { useRef, useState } from "react";
import { message } from "antd";
import AddAndEdit from "./addAndEdit";
import { httpDictServ } from "@/services/customerServices";
import { deleteNodeConfigById, findNodeConfig } from "@/services/serviceConfig";

const NodeList = () => {
    const listRef = useRef<any>();
    const [detailInfo, setDetailInfo] = useState<any>();
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const fetchList = (values: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query } = values;
                findNodeConfig(current, pageSize, query).then(data => {
                  resolve(data)
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const getStatusOptions = () => {
        return new Promise(async (resolve) => {
            try {
                const statusList = await httpDictServ({ parentKey: 'workerStatus', enable: 1, });
                resolve({
                    statusList,
                });
            } catch (e) { }
        });
    };
    const onAdd = () => {
        setDetailInfo({})
        setVisibleDrawer(true)
    }
    const toEdit = (value) => {
        setDetailInfo(value)
        setVisibleDrawer(true)
    }
    const closeDetails = () => {
        setVisibleDrawer(false)
    }
    const reloadList = () => {
        listRef.current?.reload()
    }
    const onDelete = (id: any) => {
        const dialog = SMessage.delete({
            onOk: async () => {
              try {
                const res: any = await deleteNodeConfigById(id)
                if (res.errorCode === 0) {
                  message.success('删除成功');
                  (listRef as any)?.current?.reload();
                } else {
                  message.error('删除失败');
                }
              } catch (err) {
                console.log(err)
              }
              dialog?.destroy();
            },
            onCancel: () => {
              message.warning('取消删除');
              dialog?.destroy();
            },
          });
    };
    const extension = {
        request: { fetchList, getStatusOptions },
        events: { onAdd },
        searchFormConfig: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        },
        customRender: {
            nodeStatusRender(text: any, record: any) {
                return <span>{record.enabled ? '启用' : '禁用'}</span>;
            },
            setAction(text: any, record: any) {
                return <STableActions>
                        <SActionBtn
                            auth={'nodeConfigEdit'}
                            onClick={() => {
                                toEdit(record);
                            }}
                        >
                            编辑
                        </SActionBtn>
                        <SActionBtn danger auth={'nodeConfigDel'} onClick={() => onDelete(record.id)}>
                            删除
                        </SActionBtn>
                    </STableActions>;
            },
        },
    };
    return <>
        <SBack title={`节点管理`}></SBack>
        <SLowcodeList
            config={config}
            ref={listRef} {...extension} searchMode="group" />
        <AddAndEdit record={detailInfo} visibleDrawer={visibleDrawer} closeDetails={closeDetails} reloadList={reloadList}></AddAndEdit>

    </>
}
export default (props: any) => {
    const location = useLocation()
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <NodeList {...props} />
        </KeepAlive>
    )
}